import type { UnionAddress } from "@anaconda/core/blockchain/address"
import type { Blockchain } from "@anaconda/core/blockchain/types"
import { NftSort, StatusFilterOption } from "@anaconda/core/nft/search/types"

export const getQueryInput = (
  walletAddress: UnionAddress,
  blockchains: Blockchain[],
) => ({
  sort: NftSort.RECENTLY_RECEIVED,
  pageSize: 100,
  filters: {
    status: StatusFilterOption.BUY_NOW,
    owner: walletAddress,
    blockchains,
  },
})
